import { Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector:'fare-rate-list',
    templateUrl: 'fare-rate-list.html'
})


export class FareRateListContainer {
  private sub: Subscription;
  private reqNo:string;

  constructor(
    private route: ActivatedRoute){}
  
  ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
       this.reqNo = params['id'];
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/fare/rate/list/fare-rate-list.ts